
<template>
  <div class="max-w-sm bg-pink rounded-lg shadow-xl text-white p-4 flex flex-col gap-6 after:absolute after:-bottom-3 after:h-0 after:w-0 after:border-l-[15px] after:border-r-[15px] after:border-t-[15px] after:border-l-transparent after:border-r-transparent after:border-t-pink after:bg-transparent after:left-1/2 after:-translate-x-1/2">
      <div class="flex justify-between items-center">
          <h3>Créez votre propre anarchive</h3>
          <AtomIconButton icon="close" class="bg-transparent !shadow-none !m-0" @click="$emit('close')" name="close" no-padding/>
      </div>
      <p class="text-sm text-gray-200">Explorez notre base de données créative avec le panneau de contrôle. Vous pouvez passer de de l'ordre chronologique à la grille et filtrer par tous les thèmes disponibles</p>
  </div>
</template>
<script>
import AtomIconButton from "../../global/atoms/AtomIconButton.vue";

export default {
  name: "OrganismPopup",
    components: {AtomIconButton},
}
</script>
